<template>
    <DModal
      :show-close="false"
      :isBgOverlay="true"
      :isCloseOnBgClick="false"
      @close="$emit('close')"
      :placeInTop="true"
      :appendToBody="true"
      style="z-index: 12312312312312"
    >
      <div class="d-modal" id="d-create-task-for-user" slot="insertComponent">
        <div class="d-modal__header">
          <h2 v-if="theEditItem">Redigér lønbrøk</h2>
          <h2 v-else>Opret lønbrøk</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
            <span class="icon-cross2"></span>
          </div>
        </div>
  
        <div class="d-modal__content">
            <div class="d-input-group">
            <label class="d-label">Vælg ansat *</label>
            <DSelect
                ref="userSelect"
                :items="filteredUsers"
                :multiple="false"
                :placeholder="'Vælg ansat'"
                :itemsSelected="itemsSelectedForDSelect"
                :isShowRemoveButton="false"
                @add="onSelectUser"
                @remove="onSelectUser(null)"
            />
            </div>
            <div class="d-input-group">
                <label class="d-label">Ansættelse *</label>
                <select v-model="employmentId" class="height-34 do-select width-100"
                        :disabled="!userId || !hasEmploymentsWithNumber">
                    <option v-for="employment in employments" :key="employment.id" :value="employment.id">
                    {{ employment.title }} - {{ employment.employment_number }}
                    </option>
                </select>
                <p v-if="userId && !hasEmploymentsWithNumber" class="text-explainer marg-05-top">
                    Den valgte bruger har ingen ansættelser med tjenestenummer
                </p>
            </div>
            <div class="d-tabs-container marg-05-top">
                <Tabs :tabs="tabs" :selected="activeTab" @select="changeTab" />
            </div>
            <div v-if="activeTab === 'timer'" class="d-input-group">
                <label class="d-label">Årsnorm</label>
                <input type="text" class="d-input" v-model="aarstimetal" placeholder="Timer" @input="onHoursInput" />
                <p v-if="hoursError" class="text-explainer marg-05-top" style="color: #e53e3e;">
                    Maksimal værdi er 1924
                </p>
            </div>
            <div class="d-input-group-flex" v-if="activeTab === 'loenbroek'">
                <div  class="d-input-group">
                    <label class="d-label">Løndecimal</label>
                    <input type="text" class="d-input" v-model="loendecimal" placeholder="Løndecimal" inputmode="decimal" pattern="[0-9]+([,\.][0-9]{1,2})?" @focus="$event.target.select()" @input="onLoendecimalInput"/>
                    <p v-if="loendecimalError" class="text-explainer marg-05-top" style="color: #e53e3e;">
                        Maksimal værdi er 1
                    </p>
                </div>
                <div  class="d-input-group">
                    <label class="d-label">Beskæftigelsesdecimal</label>
                    <input type="text" class="d-input" v-model="beskaefftigelsesdecimal" placeholder="Beskæftigelsesdecimal" inputmode="decimal" pattern="[0-9]+([,\.][0-9]{1,2})?" @focus="$event.target.select()" @input="onBeskaaefftigelsesdecimalInput"/>
                    <p v-if="beskaefftigelsesdecimalError" class="text-explainer marg-05-top" style="color: #e53e3e;">
                        Maksimal værdi er 1
                    </p>
                </div>
            </div>
            <div class="d-input-group">
                <label class="d-label">Dato det skal gælde fra</label>
                <DateSelector class="width-100" :date="startDate" :width100="true" @changed="setDate($event)"/>
            </div>
        </div>
        
        <div class="d-modal__buttons">
          <div class="d-modal__buttons__child">
            <button
              v-if="theEditItem"
              class="do-bttn"
              @click="isDeleteModal = true"
            >
              <span class="icon-bin"></span>
            </button>
          </div>
          <div class="d-modal__buttons__child">
            <button class="do-bttn" @click="$emit('close')">
              {{ $t('vue2.common.cancel') }}
            </button>
            <button
              v-if="!theEditItem"
              class="do-bttn do-bttn--submit"
              :class="{
                'do-bttn--submit--disabled': !isValid || isSubmitting,
                'do-bttn--submit--loading': isSubmitting
              }"
              @click="onSubmit"
            >
              {{ theEditItem ? 'Opret ny' : 'Gem' }}
            </button>
          </div>
        </div>
          <ModalConfirmation
          v-if="isDeleteModal"
          :showClose="false"
          :isSubmitButtonLoading="isDeleting"
          @close="isDeleteModal = false"
          @confirm="deleteEditItem">
        </ModalConfirmation>
      </div>
    </DModal>
  </template>
  
  <script>
  import DModal from '../../common/DModal.vue'
  import DSelect from '../../DSelect/DSelect.vue'
  import DateSelector from '../../datepicker/DateSelector.vue'
  import moment from 'moment'
  import Tabs from '../../common/Tabs.vue'
  import docendo from '../../../docendo'
  import eventbus from '../../../eventbus'
  import ModalConfirmation from '../../Modals/ModalConfirmation.vue'
  
  export default {
    name: 'LoenbroekModal',
    components: {DModal, DSelect, DateSelector, Tabs, ModalConfirmation},
    props: {
      theEditItem: {
        default: null
      }
    },
    data () {
      return {
        userId: '',
        employmentId: null,
        startDate: moment(),
        aarstimetal: 1924,
        tabs: [
          {
            title: 'Årsnorm',
            id: 'timer'
          },
          {
            title: 'Lønbrøk',
            id: 'loenbroek'
          }
        ],
        activeTab: 'timer',
        loendecimal: 1,
        beskaefftigelsesdecimal: 1,
        isSubmitting: false,
        isDeleting: false,
        isDeleteModal: false,
        hoursError: false,
        loendecimalError: false,
        beskaefftigelsesdecimalError: false
      }
    },
    computed: {
      itemsSelectedForDSelect () {
        return this.selectedUser ? [this.selectedUser] : []
      },
      usersSortedOnName () {
        return this.$store.getters.usersSortedOnName
      },
      filteredUsers () {
        return this.usersSortedOnName.filter(user => this.employmentsInUserIdHash[user.id])
      },
      selectedUser () {
        return this.usersSortedOnName.find(u => u.id === this.userId)
      },
      employmentsInUserIdHash () {
        return this.$store.getters.employmentsInUserIdHash
      },
      employmentsRaw () {
        const has = this.userId && this.employmentsInUserIdHash[this.userId]
        return has ? this.employmentsInUserIdHash[this.userId] : []
      },
      employments () {
        const src = this.employmentsRaw
        const out = []
        for (let i = 0; i < src.length; i++) {
          const e = src[i]
          const num = e && e.employment_number ? String(e.employment_number) : ''
          if (num.trim() !== '') out.push(e)
        }
        return out
      },
      hasEmploymentsWithNumber () {
        return this.userId && this.employments.length > 0
      },
      selectedEmployment () {
        const list = this.employments
        for (let i = 0; i < list.length; i++) {
          if (list[i].id === this.employmentId) return list[i]
        }
        return null
      },
      schoolId () {
        return this.$store.getters.schoolId
      },
      isValid () {
        const emp = this.selectedEmployment
        const hasEmploymentNumbers = emp && emp.employment_number
        const hasUser = !!this.userId
        const hasEmployment = !!this.employmentId
        // Hvis activeTab er 'timer', skal hours være udfyldt og større end 0 og mindre end 1924
        let hasValidHours = true
        if (this.activeTab === 'timer') {
          const hoursValue = parseFloat(String(this.aarstimetal).replace(',', '.'))
          hasValidHours = !isNaN(hoursValue) && hoursValue > 0 && hoursValue <= 1924
        }
        let hasValidLoendecimal = true
        let hasValidBeskaefftigelsesdecimal = true
        if (this.activeTab === 'loenbroek') {
          const loendecimalValue = parseFloat(String(this.loendecimal).replace(',', '.'))
          const beskaefftigelsesdecimalValue = parseFloat(String(this.beskaefftigelsesdecimal).replace(',', '.'))
          hasValidLoendecimal = !isNaN(loendecimalValue) && loendecimalValue > 0 && loendecimalValue <= 1
          hasValidBeskaefftigelsesdecimal = !isNaN(beskaefftigelsesdecimalValue) && beskaefftigelsesdecimalValue > 0 && beskaefftigelsesdecimalValue <= 1
        }
        return hasUser && hasEmployment && hasEmploymentNumbers && hasValidHours && hasValidLoendecimal && hasValidBeskaefftigelsesdecimal
      }
    },
    watch: {
      theEditItem: {
        handler () {
          this.applyEditItem()
        },
        immediate: true
      },
      // Når ansættelser loader ind i store, prøv igen hvis vi endnu ikke har sat employmentId
      employmentsInUserIdHash: {
        handler () {
          if (this.theEditItem && !this.employmentId) {
            this.applyEditItem()
          }
        },
        deep: true
      }
    },
    methods: {
      changeTab (tab) {
        this.activeTab = tab
      },
      onSelectUser (item) {
        if (!item) {
          this.userId = ''
        } else {
          this.userId = item.id
        }
        this.onUserChange()
        // Auto-select employment if user only has one
        if (item && item.id) {
          this.$nextTick(() => {
            if (this.employments && this.employments.length === 1) {
              this.employmentId = this.employments[0].id
            }
          })
        }
      },
      onUserChange () {
        this.employmentId = null
      },
      focusUserSelect () {
        const el = this.$refs && this.$refs.userSelect ? this.$refs.userSelect : null
        if (!el) return
        el.focus()
      },
      setDate (date) {
        this.startDate = date
      },
      onHoursInput (event) {
        const value = event.target.value
        const numValue = parseFloat(value.replace(',', '.'))
        if (!isNaN(numValue) && numValue > 1924) {
          this.hoursError = true
          this.aarstimetal = 1924
        } else {
          this.hoursError = false
          this.aarstimetal = numValue
        }
      },
      onLoendecimalInput (event) {
        const value = event.target.value
        const numValue = parseFloat(value.replace(',', '.'))
        if (!isNaN(numValue) && numValue > 1) {
          this.loendecimalError = true
          this.loendecimal = 1
        } else {
          this.loendecimalError = false
          this.loendecimal = value
        }
      },
      onBeskaaefftigelsesdecimalInput (event) {
        const value = event.target.value
        const numValue = parseFloat(value.replace(',', '.'))
        if (!isNaN(numValue) && numValue > 1) {
          this.beskaefftigelsesdecimalError = true
          this.beskaefftigelsesdecimal = 1
        } else {
          this.beskaefftigelsesdecimalError = false
          this.beskaefftigelsesdecimal = value
        }
      },
      applyEditItem () {
        const it = this.theEditItem
        if (!it) {
          // Reset til default værdier hvis der ikke er en editItem
          this.userId = ''
          this.employmentId = null
          this.startDate = moment()
          this.aarstimetal = 1924
          this.loendecimal = 1
          this.beskaefftigelsesdecimal = 1
          this.activeTab = 'timer'
          return
        }

        this.userId = it.user_id || ''
        this.startDate = it.dato ? moment(it.dato) : moment()

        // Sæt activeTab baseret på hvilke felter der er udfyldt
        if (it.aarstimetal != null) {
          this.activeTab = 'timer'
          this.aarstimetal = it.aarstimetal
        } else if (it.loendecimal != null || it.beskaeftigelsesdecimal != null) {
          this.activeTab = 'loenbroek'
          this.loendecimal = it.loendecimal != null ? it.loendecimal : 1
          this.beskaefftigelsesdecimal = it.beskaeftigelsesdecimal != null ? it.beskaeftigelsesdecimal : 1
        }

        // Prøv at finde ansættelsen
        let employmentId = null
        if (it.tjenestenummer) {
          const list = this.employmentsInUserIdHash && this.employmentsInUserIdHash[it.user_id]
            ? this.employmentsInUserIdHash[it.user_id]
            : []
          const match = list.find(e => String(e.employment_number) === String(it.tjenestenummer))
          if (match) employmentId = match.id
        }
        this.employmentId = employmentId
      },
      deleteEditItem () {
        if (!this.theEditItem || !this.theEditItem.id) {
          eventbus.toast = {text: 'Mangler id på lønbrøk', success: false, position: 'bottomLeft'}
          return
        }
        if (!this.schoolId) {
          eventbus.toast = {text: 'Mangler schoolId', success: false, position: 'bottomLeft'}
          return
        }

        this.isDeleting = true
        const success = (_res) => {
          this.isDeleting = false
          this.isDeleteModal = false
          eventbus.toast = {text: 'Lønbrøk slettet', success: true, position: 'bottomLeft'}
          this.$emit('deleted', {id: this.theEditItem.id})
          this.$emit('close')
        }

        const failure = (err) => {
          this.isDeleting = false
          const msg = err && err.error ? err.error : 'Kunne ikke slette lønbrøken'
          eventbus.toast = {text: msg, success: false, position: 'bottomLeft'}
        }

        docendo.deleteSilkeborgDataLoenaendring(
          this.schoolId,
          this.theEditItem.id,
          success,
          failure
        )
      },
      onSubmit () {
        if (!this.isValid) {
          return
        }
        if (!this.schoolId) {
          eventbus.toast = {text: 'Mangler schoolId', success: false}
          return
        }
        this.isSubmitting = true
        const emp = this.selectedEmployment
        const dato = moment(this.startDate)
        // Byg payload baseret på API specifikationen
        const loenaendring = {
          user_id: this.userId,
          employment_id: emp ? emp.id : null,
          tjenestenummer: emp && emp.employment_number ? String(emp.employment_number) : '',
          dato: dato.format('YYYY-MM-DD')
        }
        // Hvis activeTab er 'timer', tilføj aarstimetal
        if (this.activeTab === 'timer') {
          const aarstimetalValue = parseFloat(String(this.aarstimetal).replace(',', '.'))
          loenaendring.aarstimetal = aarstimetalValue
          // Sæt deltidskode baseret på om det er mindre end 1924 (deltid) eller 1924 (fuldtid)
          loenaendring.deltidskode = aarstimetalValue < 1924 ? 1 : 0
        }
        // Hvis activeTab er 'loenbroek', tilføj loendecimal og beskaeftigelsesdecimal
        if (this.activeTab === 'loenbroek') {
          const loendecimalValue = parseFloat(String(this.loendecimal).replace(',', '.'))
          const beskaefftigelsesdecimalValue = parseFloat(String(this.beskaefftigelsesdecimal).replace(',', '.'))
          loenaendring.loendecimal = loendecimalValue
          loenaendring.beskaeftigelsesdecimal = beskaefftigelsesdecimalValue
          // Sæt deltidskode baseret på om loendecimal er mindre end 1 (deltid) eller 1 (fuldtid)
          loenaendring.deltidskode = loendecimalValue < 1 ? 1 : 0
        }

        const success = (res) => {
          this.isSubmitting = false
          const msg = this.theEditItem ? 'Lønbrøk opdateret' : 'Lønbrøk oprettet'
          eventbus.toast = {text: msg, success: true, position: 'bottomLeft'}
          this.$emit('created', res)
          this.$emit('close')
        }
        const failure = (err) => {
          this.isSubmitting = false
          const msg = err && err.error
            ? err.error
            : this.theEditItem
              ? 'Kunne ikke opdatere lønbrøken'
              : 'Kunne ikke oprette lønbrøken'
          eventbus.toast = {text: msg, success: false, position: 'bottomLeft'}
        }

        if (this.theEditItem && this.theEditItem.id) {
          // Hvis der er et update API, brug det - ellers brug create
          if (docendo.updateSilkeborgDataLoenaendring) {
            docendo.updateSilkeborgDataLoenaendring(
              this.schoolId,
              this.theEditItem.id,
              loenaendring,
              success,
              failure
            )
          } else {
            // Fallback til create hvis update ikke findes
            docendo.createSilkeborgDataLoenaendring(this.schoolId, loenaendring, success, failure)
          }
        } else {
          docendo.createSilkeborgDataLoenaendring(this.schoolId, loenaendring, success, failure)
        }
      }
    },
    mounted () {
      this.$store.dispatch('readEmployments')
      if (this.theEditItem) {
        this.applyEditItem()
      } else {
        // Giv fokus når modalen er i DOM
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.userSelect) {
              this.$refs.userSelect.open()
            }
          }, 500)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  @import "../../../assets/css/variables.css";
  
  .d-modal {
    width: 500px;
    border-radius: 16px;
    position: relative;
  }
  
  .d-modal__header {
    margin-bottom: 0;
    text-align: left;
  }
  
  .d-modal__buttons {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1rem;
    border-top: 1px solid #eee;
    margin: 0;
  }

  .d-modal__buttons__child {
    display: flex;
    gap: 0.5rem;
  }
    
  .d-modal__content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .d-input-group--toggler {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 1rem;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
  }
  
  .d-input-group--toggler.d-input-group--toggler--active > .d-label {
    color: var(--dark-blue);
  }
  
  .d-input-group--toggler > .d-label {
    margin-bottom: 0;
    cursor: pointer;
  }
  
  .d-input-group--toggler:hover {
    background: #f0f8ff;
  }
  
  .d-input-group {
    flex: 1;
    padding: 0;
    margin: 0;
  }
  
  .d-input-group .d-input,
  .d-input-group .do-select {
    height: 34px;
    width: 100%;
    margin-top: 0.25rem;
  }
  
  .d-input-group .do-select {
    border: 1px solid #edf2f7;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
  }
  
  
  .d-input-group-flex {
    display: flex;
    gap: 1rem;
  }
  
  .d-input-group-flex > div {
    flex: 1;
  }
  
  .d-input-group-flex label.d-label {
    margin-bottom: 0.25rem;
  }
  
  .d-input.is-invalid,
  .is-invalid.d-input {
    border-color: #e53e3e;
    box-shadow: 0 0 0 1px rgba(229,62,62,.2);
  }
  
  </style>
  


// WEBPACK FOOTER //
// LoenbroekModal.vue?1202f73a